import { on } from "@ngrx/store";
import { SalesOrderState } from "../sales-order.state";
import { SalesOrdersActions } from "./sales-orders.actions";
import { UserActions } from "../../../user/user.actions";
import { PagesStore } from "../../pages.state";

// ============================================================================
// HELPER: Update salesOrder state within PagesStore
// ============================================================================

function withSalesOrder(state: PagesStore, updater: (salesOrder: SalesOrderState) => SalesOrderState): PagesStore {
    return { ...state, salesOrder: updater(state.salesOrder) };
}

// ============================================================================
// SALES ORDERS LIST REDUCER (flattened structure)
// ============================================================================

const load = on(
    SalesOrdersActions.load,
    (state: PagesStore) => withSalesOrder(state, salesOrderState => ({
        ...salesOrderState,
        loadingList: true,
    })),
);

// loadSuccess saves everything in one action
const loadSuccess = on(
    SalesOrdersActions.loadSuccess,
    (state: PagesStore, { result, params }) => withSalesOrder(state, salesOrderState => ({
        ...salesOrderState,
        salesOrders: result.salesOrders ?? [],
        loaded: true,
        pageNumber: params.pagination.pageNumber,
        pageSize: params.pagination.pageSize,
        totalCount: result.totalCount ?? 0,
        sortProperty: params.sorting.sortProperty,
        sortAscending: params.sorting.sortAscending,
        orderNo: params.orderNo,
        externalDocumentNo: params.externalDocumentNo,
        salesChannelCode: params.salesChannelCode,
        customerContactName: params.customerContactName,
        customerNo: params.customerNo,
        salespersonCode: params.salespersonCode,
        loadingList: false,
        error: null,
    })),
);

const loadFailure = on(
    SalesOrdersActions.loadFailure,
    (state: PagesStore, { error }) => withSalesOrder(state, salesOrderState => ({
        ...salesOrderState,
        loadingList: false,
        error,
    })),
);

const invalidate = on(
    SalesOrdersActions.invalidate,
    UserActions.changeCompanySuccess,
    (state: PagesStore) => withSalesOrder(state, salesOrderState => ({
        ...salesOrderState,
        loaded: false,
    })),
);

export const salesOrdersReducer = [load, loadSuccess, loadFailure, invalidate];
